<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Laboratory Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${laboratory.name}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit laboratory'">
      <template #gated-content>
        <laboratory-form :laboratory="laboratory" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import LaboratoryForm from "@/components/lab/laboratory/LaboratoryForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { laboratoryNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const LaboratoryRepository = LabRepositoryFactory.get("laboratory");

export default {
  name: "LaboratoryEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    LaboratoryForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$route.params.laboratory_id || null,
      laboratory: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "laboratory",
            title: "Laboratory list",
          },
          {
            icon: "fa-eye",
            linkto: `/laboratory/${this.laboratory_id}`,
            title: "View laboratory",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(payload) {
      try {
        await LaboratoryRepository.update(this.laboratory_id, payload);

        this.editSuccess();
        this.$router.push(`/laboratory/${this.laboratory_id}`);
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.laboratory = await getModel({
      model_type: "laboratory",
      id: this.laboratory_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: laboratoryNotifications,
};
</script>
